import { preRegistrationsActions } from '../actions'
import ValidateFormObject, { validates } from '../utils/ValidateFormObject'

const {
  ADD_PRE_REGISTRATION,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  CHANGE_PRE_REGISTRATION,
  CLOSE_MODAL,
  DELETE_PRE_REGISTRATION,
  EDIT_PRE_REGISTRATION,
  FETCH_PRE_REGISTRATION_ERROR,
  FETCH_PRE_REGISTRATION,
  FETCH_PRE_REGISTRATIONS_ERROR,
  FETCH_PRE_REGISTRATIONS,
  FETCHING_PRE_REGISTRATION,
  FETCHING_PRE_REGISTRATIONS,
  FORM_TOUCHED,
  NEW_FORM_PRE_REGISTRATION,
  OPEN_MODAL,
  PRE_REGISTRATION_FORM_ERROR,
  RESET_STATE
} = preRegistrationsActions

const initialState = {
  loadingPreRegistration: false,
  loadingPreRegistrations: false,
  fetchPreRegistrationError: false,
  fetchPreRegistrationsError: false,
  preRegistrations: [],
  order: {
    column: 'titulo',
    direction: 1
  },
  preRegistrationsPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  preRegistration: {
    autores: '',
    especialidades: '',
    tipo: '',
    titulo: '',
    isbn: '',
    codigo: '',
    copyright: '',
    edicao: ''
  },
  preRegistrationFormErrors: {},
  preRegistrationFormTouched: false,
  modalOpen: false
}

const preRegistrationSchema = {
  common: {
    tipo: {
      required: true
    }
  },
  curso: {
    tipo: {
      required: true
    },
    titulo: {
      maxValue: 255,
      minValue: 3,
      required: true
    },
    autores: {
      required: true
    },
    especialidades: {
      required: true
    },
    codigo: {
      required: true,
      func: validates.isbn,
      errorMessage: 'Este campo deve conter um número de ISBN válido.'
    },
    copyright: {
      required: true,
      func: validates.copyright,
      errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
    },
    edicao: {
      required: true
    }
  },
  livro: {
    tipo: {
      required: true
    },
    titulo: {
      maxValue: 255,
      minValue: 3,
      required: true
    },
    autores: {
      required: true
    },
    especialidades: {
      required: true
    },
    isbn: {
      required: true,
      func: validates.isbn,
      errorMessage: 'Este campo deve conter um número de ISBN válido.'
    },
    codigo: {
      required: true,
      func: validates.isbn,
      errorMessage: 'Este campo deve conter um número de ISBN válido.'
    },
    copyright: {
      required: true,
      func: validates.copyright,
      errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
    },
    edicao: {
      required: true
    }
  }
}

const PreRegistrationValidate = new ValidateFormObject(preRegistrationSchema)

const preRegistrations = (state = initialState, action = {}) => {
  switch (action.type) {
    case CHANGE_PRE_REGISTRATION:
      return {
        ...state,
        preRegistration: action.preRegistration,
        preRegistrationFormErrors: PreRegistrationValidate.validate({
          formObject: action.preRegistration,
          formSchemaType: (action.preRegistration || {}).tipo || 'common'
        })
      }

    case PRE_REGISTRATION_FORM_ERROR:
      const formErrors = {}
      formErrors[action.field] = { valid: false, errorMessage: action.message }

      return {
        ...state,
        preRegistrationFormErrors: PreRegistrationValidate.validate({
          formObject: state.preRegistration,
          invalidFields: formErrors,
          formSchemaType: (action.preRegistration || {}).tipo || 'common'
        })
      }

    case NEW_FORM_PRE_REGISTRATION:
      return {
        ...state,
        preRegistration: { ...initialState.preRegistration },
        preRegistrationFormErrors: PreRegistrationValidate.validate({}),
        preRegistrationFormTouched: false
      }

    case FORM_TOUCHED:
      return {
        ...state,
        preRegistrationFormTouched: true
      }

    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }

    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }

    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }

    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }

    case CHANGE_PAGE:
      return {
        ...state,
        preRegistrationsPagination: {
          ...state.preRegistrationsPagination,
          page: action.page
        }
      }

    case CHANGE_PER_PAGE:
      return {
        ...state,
        preRegistrationsPagination: {
          ...state.preRegistrationsPagination,
          rowsPerPage: action.perPage
        }
      }

    case FETCH_PRE_REGISTRATION:
      return {
        ...state,
        preRegistration: action.preRegistration,
        loadingPreRegistration: false,
        fetchpreRegistrationError: false,
        preRegistrationFormTouched: false,
        preRegistrationFormErrors: PreRegistrationValidate.validate({
          formObject: action.preRegistration,
          formSchemaType: action.preRegistration || {} || 'common'
        })
      }

    case FETCHING_PRE_REGISTRATION:
      return {
        ...state,
        loadingPreRegistration: true,
        fetchPreRegistrationError: false
      }

    case DELETE_PRE_REGISTRATION:
      return {
        ...state,
        loadingPreRegistrations: false,
        fetchPreRegistrationError: false,
        preRegistrations: state.preRegistrations.map(preRegistration => {
          if (preRegistration._id === action.preRegistration._id) {
            return action.preRegistration
          }

          return preRegistration
        })
      }

    case FETCH_PRE_REGISTRATION_ERROR:
      return {
        ...state,
        loadingPreRegistration: false,
        preRegistration: { ...initialState.preRegistration },
        fetchPreRegistrationError: action.error
      }

    case FETCH_PRE_REGISTRATIONS:
      return {
        ...state,
        loadingPreRegistrations: false,
        preRegistrations: action.preRegistrations,
        fetchPreRegistrationsError: false,
        order: action.order,
        preRegistrationsPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }

    case EDIT_PRE_REGISTRATION:
      return {
        ...state,
        preRegistrations: state.preRegistrations.map(preRegistration => {
          if (preRegistration._id === action.preRegistration._id) {
            return action.preRegistration
          }

          return preRegistration
        }),
        loadingPreRegistrations: false,
        fetchPreRegistrationError: false,
        loadingPreRegistration: false,
        fetchPreRegistrationsError: false
      }

    case FETCHING_PRE_REGISTRATIONS:
      return {
        ...state,
        loadingPreRegistrations: true,
        fetchPreRegistrationsError: false
      }

    case FETCH_PRE_REGISTRATIONS_ERROR:
      return {
        ...state,
        loadingPreRegistrations: false,
        fetchPreRegistrationError: action.error,
        loadingPreRegistration: false
      }

    case ADD_PRE_REGISTRATION:
      return {
        ...state,
        loadingPreRegistrations: false,
        fetchPreRegistrationError: false,
        loadingPreRegistration: false,
        preRegistrations: [...state.preRegistrations, action.preRegistration]
      }

    case RESET_STATE:
      return initialState

    default:
      return state
  }
}

export default preRegistrations



// WEBPACK FOOTER //
// ./src/reducers/preRegistrations.js